import React, { Component } from 'react';

/**
 * Component for showing header on a page.
 *
 * @extends React.Component
 */
class PageHeader extends Component {
  /** @inheritdoc */
  render() {
    return (
      <div className="row">
        <div className="col-sm-3">
          <h1>{this.props.label}</h1>
        </div>
      </div>
    );
  }
}

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader/index.js